import React, { useEffect, useState } from 'react';
import { Modal, Box, } from '@mui/material';
import Loading from '../Input/Loading.js';
import CustomTextField from '../Input/input.jsx';
import cancelIcon from '../../Assets/Images/cancelIcon.svg'
import { Link } from 'react-router-dom';
import Button from '../Input/Button.js';
import postService from '../../Services/post-service.js';
import cookie from "react-cookies";
import { toast } from 'react-toastify';
import axios from 'axios';
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  // p: 4,
};

const PurchaseSchoolBill = ({ open, handleClose }) => {
    const [loading, setLoading] = useState(false)
    const [id, setId] = useState('')
    const [phone, setPhone] = useState('')
    const [amount, setAmount] = useState(8)
    const [pin, setPin] = useState('')
    const [waecList, setWaecList] = useState([])
    const [waecValue, setWaecValue] = useState('')
    const [waecAva, setWaecAva] = useState('')
    const [jambValue, setJambValue] = useState('')
    const [jambList, setJambList] = useState([])
    const [acc, setAcc] = useState('')
    const token = cookie.load("TOPUPCLIQ_USER_TOKEN");
  
    const handleSelect = (event) => {
      const selectedItem = waecList.find(item => item.description === event.target.value);
      if (selectedItem) {
        setWaecValue(selectedItem.description);
        setAmount(selectedItem.amount);
        setWaecAva(selectedItem.available)
      }
    };
  
    const handleSelect2 = (event) => {
      const selectedItem = jambList.find(item => item.product_code === event.target.value);
      if (selectedItem) {
        setJambValue(selectedItem.product_code);
        setAmount(selectedItem.amount);
      }
    };
  
   
  useEffect(() =>{
      
    setLoading(true)
    axios
      .post(`/bills/bundles`,{
        "service_type": "waec"
      }, {
        headers: {
          authorization: token,
        },
      }).then(
      (response) => {
          console.log(response.data)
          setLoading(false)
         if(response.data.status === '2000'){
          setWaecList(response.data.data.data)
         
         }else{  
        
          toast.error(response.data.description,)
         }
         
        },
        (error) => {
          setLoading(false)
            return  toast.error('Error occured. Try again shortly',)
          }
  
    )
  axios
      .post(`/bills/jamb-pricing-option`,{
        "service_type": "jamb"
      }, {
        headers: {
          authorization: token,
        },
      }).then(
      (response) => {
          console.log(response.data)
          setLoading(false)
         if(response.data.status === '2000'){
          setJambList(response.data.data.data)
         
         }else{  
        
          toast.error(response.data.description,)
         }
         
        },
        (error) => {
          setLoading(false)
            return  toast.error('Error occured. Try again shortly',)
          }
          
    )
  
  },[token])
  
  const onSubmit = (e) =>{
    e.preventDefault()
    setLoading(true)
    if(id === 'waec'){
      axios
      .post( '/api/waec-pin',{
        "service_type": "waec",
        "numberOfPins": 1,
        "pinValue":waecAva,
        "amount" : amount,
        "agentReference": "kfmc2c3d8987d223",
        "transactionPin": pin
      }, {
        headers: {
          authorization: token,
        },
      }).then(
          (response) => {
              console.log(response.data)
              setLoading(false)
             if(response.data.status === '2000'){
             
              toast.success(response.data.description)
              setTimeout(() => {
                window.location.reload()
              }, 2000);
             }else{  
              toast.error(response.data.description,)
             }
             
            },
            (error) => {
              setLoading(false)
                return  toast.error('Error occured. Try again shortly',)
              }
        )
    }
    if(id === 'jamb'){
      axios
      .post('/api/jamb-pin',{
        "service_type" : "jamb",
        "account_number" : acc,
        "product_code" : jambValue,
        "phone" : phone,
        "amount" : amount,
        "agentReference" : "100306543008",
        "transactionPin" : pin
      }, {
        headers: {
          authorization: token,
        },
      }).then(
          (response) => {
              console.log(response.data)
              setLoading(false)
             if(response.data.status === '2000'){
             
              toast.success(response.data.description)
              setTimeout(() => {
                window.location.reload()
              }, 2000);
             }else{  
              toast.error(response.data.description,)
             }
             
            },
            (error) => {
              setLoading(false)
                return  toast.error('Error occured. Try again shortly',)
              }
        )
    }
   
  }
    
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
    >
  

        <Box sx={modalStyle} className='rounded-lg p-5 w-full'>
        <Loading
          open={loading}
        />
        <header className='flex justify-between items-center mb-10 py-5 px-3 bg-white shadow-sm w-full fixed top-0 left-0 h-[60px] z-10 rounded-lg'>
       

        <h1 className='text-custom-black text-[18px] font-[700]'>
        School and Exams
        </h1>
        <Link className='cursor-pointer' onClick={handleClose}>
        <img src={cancelIcon} alt="" />
        </Link>

      </header>
       <form onSubmit={onSubmit} className=' mt-5'>
       <div>
      <label className=' block font-medium mb-2'>Avaliable Exam</label>
      <select value={id} onChange={(e) => {
       setId(e.target.value)
       setAmount(0)
       setJambValue('')
       setWaecValue('')
      } } required className=' w-full border rounded p-3 mb-4'>
        <option value={''}>Select Exam</option>
        <option value={'waec'}>WAEC</option>
        <option value={'jamb'}>JAMB</option>
       </select>
      </div>
      {id === 'waec' ?
        <div>
      <label className=' block font-medium mb-2'>WAEC Exam type</label>
      <select value={waecValue} onChange={handleSelect} required className=' w-full border rounded p-3 mb-4'>
        <option value={''}>Select type</option>
        {waecList.map((e, index) =>{
          return  <option key={index} value={e.description}>{e.description}</option>
        })}
       </select>
      </div>
      :id === 'jamb' ?<div>
      <label className=' block font-medium mb-2'>Jamb Exam type</label>
      <select value={jambValue} onChange={handleSelect2} required className=' w-full border rounded p-3 mb-4'>
        <option value={''}>Select type</option>
        {jambList.map((e, index) =>{
          return  <option key={index} value={e.product_code}>{e.product_code}</option>
        })}
       </select>
      </div>: <></>}
      <CustomTextField
       type='text' 
       disabled= {true}
       value={amount}
       label={'Amount'}
        placeholder='Amount' />
        {id === 'jamb' &&
          <CustomTextField
       type='text' 
       value={acc}
       onChange={setAcc}
       label={'Account number'}
        placeholder='00000000' />
        }
      <CustomTextField
       type='text' 
       value={phone}
       label={'Phone number'}
       onChange={setPhone}
        placeholder='090230000000' />
    
    
    
        <CustomTextField
                    value={pin}
                    required
                    name={'pin'}
                    onChange={setPin}
                     type='password' label='PIN'/> 
                    
                    <div className=' mt-4'>
                    <Button
                        name={'Submit'}
                        />
                    </div>
       </form>
       
        </Box>
    </Modal>
  );
};

export default PurchaseSchoolBill;
